"use client";

import React from "react";
import { Button, Tooltip } from "@/ui";
import { colors, spacing } from "@/ui/tokens";
import { Add, Settings } from "@mui/icons-material";
import { useChatStore } from "@/lib/sola/store";
import chatStyles from "../ChatInterface.module.css";

export function ChatHeader({ onNewChat }) {
  const setSettingsOpen = useChatStore((s) => s.setSettingsOpen);

  return (
    <div
      style={{
        height: 48,
        paddingLeft: spacing[4],
        paddingRight: spacing[4],
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: spacing[2],
        backgroundColor: colors.canvas.default,
        borderBottom: `1px solid ${colors.border.subtle}`,
      }}
    >
      <Tooltip content="Settings">
        <button
          type="button"
          onClick={() => setSettingsOpen(true)}
          className={chatStyles.settingsButton}
        >
          <Settings style={{ fontSize: 18 }} />
        </button>
      </Tooltip>
      <Button
        variant="primary"
        size="sm"
        onClick={onNewChat}
        style={{ gap: spacing[1] }}
      >
        <Add style={{ fontSize: 16 }} />
        New Chat
      </Button>
    </div>
  );
}
